import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { INCIDENT_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

const mutateAddIncident = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(
    `${INCIDENT_API(data?.communityId)}`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useAddIncidentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddIncident,
    ...queryParams,
  });

export default useAddIncidentMutation;
